import { render, staticRenderFns } from "./Articles.Dialog.vue?vue&type=template&id=47d629af&scoped=true&"
import script from "./Articles.Dialog.vue?vue&type=script&lang=js&"
export * from "./Articles.Dialog.vue?vue&type=script&lang=js&"
import style0 from "./Articles.Dialog.vue?vue&type=style&index=0&id=47d629af&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47d629af",
  null
  
)

export default component.exports